import { render, staticRenderFns } from "./UploadDokumen.html?vue&type=template&id=47f0b8be&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./UploadDokumen.scss?vue&type=style&index=0&id=47f0b8be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f0b8be",
  null
  
)

export default component.exports